import { F0ActionBar } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'

interface AcknowledgementBarProps {
  loading: boolean
  acknowledging: boolean
  hasAcknowledged: boolean
  pageAckVersion?: number | null
  onAcknowledge: () => void
  isEditing: boolean
}

export const AcknowledgementBar = ({
  loading,
  acknowledging,
  hasAcknowledged,
  pageAckVersion,
  onAcknowledge,
  isEditing,
}: AcknowledgementBarProps) => {
  return (
    <F0ActionBar
      isOpen={!loading && !hasAcknowledged && !!pageAckVersion && !isEditing}
      label={i18n.t('pages.page.acknowledgement.title')}
      primaryActions={[
        {
          label: i18n.t('pages.page.acknowledgement.ok_i_understand'),
          onClick: onAcknowledge,
        },
      ]}
    />
  )
}
